import { LOGIN_REQUEST, LOGIN_SUCCESS , LOGIN_FAILED , 
        GET_USER_PROFILE_REQUEST , GET_USER_PROFILE_SUCCESS , GET_USER_PROFILE_FAILED,
LOGOUT } from "./types"



export const loginRequest = () => ({type:LOGIN_REQUEST})
export const loginSuccess = (authData) => ({type:LOGIN_SUCCESS , payload : authData})
export const loginFailed = (error) => ({type:LOGIN_FAILED, payload:error})


export const getUserProfileRequest = () => ({type:GET_USER_PROFILE_REQUEST })
export const getUserProfileSuccess = (profileData) => ({type:GET_USER_PROFILE_SUCCESS , payload : profileData})
export const getUserProfileFailed = (error) => ({type:GET_USER_PROFILE_FAILED, payload:error})


export const logout = () => ({type: LOGOUT})